import { render, staticRenderFns } from "./InsightParameters.vue?vue&type=template&id=f907c490&scoped=true&"
import script from "./InsightParameters.vue?vue&type=script&lang=ts&"
export * from "./InsightParameters.vue?vue&type=script&lang=ts&"
import style0 from "./InsightParameters.vue?vue&type=style&index=0&id=f907c490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f907c490",
  null
  
)

export default component.exports